import { Paper, PaperProps, alpha, useTheme } from "@mui/material";

export default function AccentPaper({ sx, ...props }: PaperProps) {
    const theme = useTheme();
    return <Paper sx={{
        background: theme.palette.info.light, //`linear-gradient(82.09deg, ${alpha(theme.palette.primary.light, .1)} -12.21%, ${alpha(theme.palette.primary.main, .15)} 104.25%)`,
        p: 2,
        ...sx
    }} elevation={0} {...props} />;
}